import { ApiService } from './ApiService';
import { IGetAllResponse } from '../Utilis/Types/Generic';
import { Question, QuestionsGroup, TaskStep } from '../Utilis/Types/Task';
export class OnboardingService extends ApiService {
  static pathName = '/onboarding';

  static getQuestions = (): Promise<
    IGetAllResponse<Question & QuestionsGroup>
  > => {
    return this.get(`${this.pathName}/questions`);
  };

  static getSteps = (): Promise<IGetAllResponse<TaskStep>> => {
    return this.get(`${this.pathName}/steps`);
  };
}
